// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Services page — supplementary styles
   These layer on top of the existing theme (tc-services-style1, butn,
   bg-orange1, color-orange1, color-666, fsz-* etc.) and only touch the
   new markup below, so nothing on the homepage services section is
   affected.
-------------------------------------------------------------------*/

.services-pg-style2 .intro-row {
  max-width: 780px;
  margin-left: auto;
  margin-right: auto;
}

.services-pg-style2 .services-list {
  display: flex;
  flex-direction: column;
  gap: 110px;
  margin-top: 20px;
}

.services-pg-style2 .service-row {
  display: flex;
  align-items: center;
  gap: 60px;
}

.services-pg-style2 .service-row.reverse {
  flex-direction: row-reverse;
}

.services-pg-style2 .service-row-img,
.services-pg-style2 .service-row-content {
  flex: 1 1;
  min-width: 320px;
}

.services-pg-style2 .service-row-img {
  position: relative;
}

.services-pg-style2 .img-wrap {
  display: block;
  border-radius: 18px;
  overflow: hidden;
  aspect-ratio: 4 / 3;
}

.services-pg-style2 .img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.services-pg-style2 .service-row:hover .img-wrap img {
  transform: scale(1.06);
}

.services-pg-style2 .service-index {
  position: absolute;
  bottom: -22px;
  left: -22px;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
}

.services-pg-style2 .service-row.reverse .service-index {
  left: auto;
  right: -22px;
}

.services-pg-style2 .service-row-content .icon {
  width: 62px;
  height: 62px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin-bottom: 24px;
}

.services-pg-style2 .service-row-content h3 {
  line-height: 1.25;
}

.services-pg-style2 .service-row-content h3 a {
  color: inherit;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.services-pg-style2 .service-row-content h3 a:hover {
  opacity: 0.7;
}

.services-pg-style2 .service-points {
  list-style: none;
  padding: 0;
  margin: 0 0 34px;
}

.services-pg-style2 .service-points li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 15px;
}

.services-pg-style2 .service-points li i {
  font-size: 13px;
}

.services-pg-style2 .service-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  text-decoration: none;
  color: inherit;
  border-bottom: 1px solid currentColor;
  padding-bottom: 4px;
  transition: gap 0.3s ease, opacity 0.3s ease;
}

.services-pg-style2 .service-link:hover {
  gap: 14px;
  opacity: 0.75;
}

@media (max-width: 991px) {
  .services-pg-style2 .services-list {
    gap: 90px;
  }

  .services-pg-style2 .service-row,
  .services-pg-style2 .service-row.reverse {
    flex-direction: column;
    gap: 40px;
  }

  .services-pg-style2 .service-index {
    left: 20px !important;
    right: auto !important;
    bottom: -18px;
    width: 60px;
    height: 60px;
    font-size: 17px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/innerpage/services/services-page.css"],"names":[],"mappings":"AAAA;;;;;;oEAMoE;;AAEpE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,SAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ------------------------------------------------------------------\n   Services page — supplementary styles\n   These layer on top of the existing theme (tc-services-style1, butn,\n   bg-orange1, color-orange1, color-666, fsz-* etc.) and only touch the\n   new markup below, so nothing on the homepage services section is\n   affected.\n-------------------------------------------------------------------*/\n\n.services-pg-style2 .intro-row {\n  max-width: 780px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.services-pg-style2 .services-list {\n  display: flex;\n  flex-direction: column;\n  gap: 110px;\n  margin-top: 20px;\n}\n\n.services-pg-style2 .service-row {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n}\n\n.services-pg-style2 .service-row.reverse {\n  flex-direction: row-reverse;\n}\n\n.services-pg-style2 .service-row-img,\n.services-pg-style2 .service-row-content {\n  flex: 1 1 0;\n  min-width: 320px;\n}\n\n.services-pg-style2 .service-row-img {\n  position: relative;\n}\n\n.services-pg-style2 .img-wrap {\n  display: block;\n  border-radius: 18px;\n  overflow: hidden;\n  aspect-ratio: 4 / 3;\n}\n\n.services-pg-style2 .img-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s ease;\n}\n\n.services-pg-style2 .service-row:hover .img-wrap img {\n  transform: scale(1.06);\n}\n\n.services-pg-style2 .service-index {\n  position: absolute;\n  bottom: -22px;\n  left: -22px;\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 600;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);\n}\n\n.services-pg-style2 .service-row.reverse .service-index {\n  left: auto;\n  right: -22px;\n}\n\n.services-pg-style2 .service-row-content .icon {\n  width: 62px;\n  height: 62px;\n  border-radius: 50%;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 26px;\n  margin-bottom: 24px;\n}\n\n.services-pg-style2 .service-row-content h3 {\n  line-height: 1.25;\n}\n\n.services-pg-style2 .service-row-content h3 a {\n  color: inherit;\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.services-pg-style2 .service-row-content h3 a:hover {\n  opacity: 0.7;\n}\n\n.services-pg-style2 .service-points {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 34px;\n}\n\n.services-pg-style2 .service-points li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  font-size: 15px;\n}\n\n.services-pg-style2 .service-points li i {\n  font-size: 13px;\n}\n\n.services-pg-style2 .service-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  text-decoration: none;\n  color: inherit;\n  border-bottom: 1px solid currentColor;\n  padding-bottom: 4px;\n  transition: gap 0.3s ease, opacity 0.3s ease;\n}\n\n.services-pg-style2 .service-link:hover {\n  gap: 14px;\n  opacity: 0.75;\n}\n\n@media (max-width: 991px) {\n  .services-pg-style2 .services-list {\n    gap: 90px;\n  }\n\n  .services-pg-style2 .service-row,\n  .services-pg-style2 .service-row.reverse {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .services-pg-style2 .service-index {\n    left: 20px !important;\n    right: auto !important;\n    bottom: -18px;\n    width: 60px;\n    height: 60px;\n    font-size: 17px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
